export const colors = {
  /**
   * Colors designated as official Primary and Secondary variants as per the new
   * design patterns. Organized by the Material UI 0 to 900 tonal designation
   * https://material.io/design/color/the-color-system.html#color-usage-and-palettes
   * Eg: theme.colors.primary[900]
   * TODO: Reserved terms like 'primary' and 'secondary' should be used, but we should also consider explicitly
   *  adding violet[100...900] colors and reference them here. Add all color variants when they are eventually
   *  published by design.
   */
  primary: {
    900: '#2F2256',
    650: '#6633CC',
    200: '#CCC0FD'
  },
  secondary: {
    blue: {
      600: '#1976D2', // TODO: Need to get confirmation of the tonal designation for this.
      100: '#CCE5FF'
    }
  },
  neutral: {
    gray: {
      250: '#D0D1C8'
    }
  }
}
